import type { InviteDto } from "@ied/shared-types";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetInvite(
	inviteCode?: string,
	options?: Omit<
		UseQueryOptions<InviteDto, Error, InviteDto, string[]>,
		"queryKey" | "queryFn"
	>,
) {
	return useQuery<InviteDto, Error, InviteDto, string[]>({
		queryKey: ["invites", inviteCode ?? ""],
		enabled: !!inviteCode,
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/invites/${inviteCode}`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch invite");
			}

			return (await res.json()) as InviteDto;
		},
		...options,
	});
}
